var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { FloatingWrapper } from '../utils/floating/index.js';
import { useMultiselect } from './MultiselectContext.js';
export const MultiselectItems = forwardRef((props, ref) => {
    const { children, className, variant = 'default' } = props, rest = __rest(props, ["children", "className", "variant"]);
    const { isOpen, getMenuProps } = useMultiselect();
    if (variant === 'unstyled') {
        return (React.createElement("ul", Object.assign({}, getMenuProps(Object.assign({ ref }, rest), { suppressRefError: true })), children));
    }
    return (React.createElement(FloatingWrapper, { open: isOpen, sameWidth: true, skipTransition: true },
        React.createElement("ul", Object.assign({ className: clsx('w-full bg-surface shadow-lg max-h-60 rounded-md py-1 text-base border border-line-subdued overflow-auto', 'empty:hidden', 'focus-visible:ring-1 focus:outline-none', !isOpen && 'invisible', className) }, getMenuProps(Object.assign({ ref }, rest), { suppressRefError: true })), children)));
});
export const MultiselectItemsEmpty = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('text-content', 'cursor-default select-none relative py-2 ps-3 pe-9', className) }, rest),
        React.createElement("span", { className: "font-normal block truncate" }, children)));
};
//# sourceMappingURL=MultiselectItems.js.map